import React from 'react';
import { useHistory } from 'react-router-dom';
import { useStyletron } from 'baseui';
import _keys from 'lodash/keys';
import _map from 'lodash/map';
import { Card } from 'baseui/card';
import { CardItem } from 'commons-ui';
import usePermission from 'commons-ui/src/permission/usePermission';
import { DASHBOARD_RESOURCES } from 'constant';
import { URL, LABEL, LOTTERY_RESOURCES, IMAGE_SOURCE } from './lotteryHelper';
import { cardCSS, keyHeading, subKeyHeading } from './styles';

const useLotteryHome = () => {
	const { hasPermission } = usePermission();
	const isEnabled = (subEntity: string) => {
		return hasPermission({
			configPageName: DASHBOARD_RESOURCES.lottery,
			configResourceName: subEntity
		});
	};
	return { isEnabled };
};

const LotteryHome: React.FC = () => {
	const history = useHistory();
	const { isEnabled } = useLotteryHome();
	const [css] = useStyletron();

	return (
		<div className={css(keyHeading)}>
			{_map(_keys(LOTTERY_RESOURCES), (subEntity) => {
				return isEnabled(subEntity) ? (
					<div
						key={subEntity}
						className={css(subKeyHeading)}
						role='button'
						tabIndex={0}
						onClick={(e) => {
							e.preventDefault();
							history.push(URL[subEntity]);
						}}>
						<Card
							overrides={{
								Root: {
									style: () => cardCSS
								},
								Body: {
									component: () => <CardItem label={LABEL[subEntity]} img={IMAGE_SOURCE[subEntity]} />
								}
							}}
						/>
					</div>
				) : null;
			})}
		</div>
	);
};

export default LotteryHome;
